export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    marginBottom: '1.5rem',
  },
}
